import { get, isObject } from 'lodash';
import { queryItem2queryLayoutItem, queryLayoutItem2Text, dataExplorerItem2Text, item2Text } from './discoveryFilter';
import { formatDateTime } from '../config/config';
import { formatNumberByKilo } from 'library-@/utils/formatNumber';
import dayjs from 'dayjs';

// 两种基本结构
// data:{
//   history_maps[{},{}]
// }

// data:{
//   history_maps[{
//     date:"",
//     data:[{}]
//   },{}]
// }
// 获取yyyy-mm-dd HH:mm
/*
 第一步:将数据中的key值洗成你需要的值 data原数据入参 keyMap对应的替换字段
*/
function transitionKey (Obj, keyMap) {
    function ergTransition (Obj) {
        let newObj = Obj.constructor === Array ? [] : {};
        for (let key in Obj) {
            //如果无替换就用原来的
            let newKey = keyMap[key] ? keyMap[key] : key;
            //递归清洗key
            newObj[newKey] = isObject(Obj[key]) ? ergTransition(Obj[key], keyMap) : Obj[key];
        }
        return newObj;
    }
    return ergTransition(Obj);
}
/*
 第二步:一层结构的数据提取date转成两层的结构
*/
function extractDate (Obj) {
    // 不能用时间戳对比，先转成YYYY-MM-DD
    if (!Obj.history_maps) {
        return;
    }
    Obj.history_maps.forEach(ele => {
        // dayTime 用来做第二种数据格式的分类  原本的时间戳保留
        ele.dayTime = formatDateTime(ele.time, 'date');
    });
    //tempArr用来判断是否是相同的时间
    let tempArr = [];
    let new_history_maps = [];
    for (let i = 0; i < Obj.history_maps.length; i++) {
        if (tempArr.indexOf(Obj.history_maps[i].time) === -1) {
            new_history_maps.push({
                date: Obj.history_maps[i].dayTime,
                data: Obj.history_maps[i]
            });
            tempArr.push(Obj.history_maps[i].time);
        } else {
            for (let j = 0; j < new_history_maps.length; j++) {
                if (new_history_maps[j].time === Obj.history_maps[i].time) {
                    new_history_maps[j].data.push(Obj.history_maps[i]);
                    break;
                }
            }
        }
    }
    Obj.history_maps = new_history_maps;
    // 日期之下按时间戳排序
    Obj.history_maps.sort(compare('time'));
    return Obj;
}
/*
 第三步:双层结构合并同日期
*/
function mergeDate (arr) {
    let tempList = [];
    let resultList = [];
    //合并date相同的对象
    arr.forEach(item => {
        if (tempList.indexOf(item.date) === -1) {
            tempList.push(item.date);
            resultList.push({
                date: item.date,
                data: []
            });
        }
    });
    resultList.forEach(res => {
        arr.forEach(item => {
            if (res.date === item.date) {
                delete item.date;
                res.data.push(item.data);
            }
        });
    });
    return resultList;
}
// 日期之下按时间戳排序
function compare (prop) {
    return function (a, b) {
        return b[prop] - a[prop];
    };
}

// analytics 可能用来调用过滤key
export function dataFilter (data, keyMap, type) {
    if (type && Object.prototype.toString.call(type) !== Boolean) type = true;
    let defaultKeyMap = {
        results: 'history_maps',
        query_list: 'history_maps',
        items: 'history_maps',
        records: 'history_maps',
        created_at: 'time',
        create_at: 'time',
    };
    // 只要不是false都只转key
    let extract;
    if (type === true) {
        extract = transitionKey(data, Object.assign({}, keyMap, defaultKeyMap));
    } else {
        let newdata = transitionKey(data, Object.assign({}, keyMap, defaultKeyMap));
        extract = extractDate(newdata);
    }
    return extract;
}
// 直接提供 discovery chemical 需要的接口

// analystic
export function analyticSearch(data, keyMap, type) {
    let newdata = dataFilter(data, keyMap, type);
    const status = ['PENDING', 'PENDING', 'SUCCESS', 'FAIL'];
    newdata.history_maps.forEach(items => {
        items.date = formatDateTime(items.date, 'date');
        if (items.data && items.data.length) {
            items.data.forEach((item, index) => {
                item.link = item.link ? item.link.replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
                item.q = item.q ? item.q.replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
                item.resultCount = get(item, 'count.number', 0);
                item._hasSetting = !!item.search_setting;
                item.createTime = item.time;
                item.updateTime = item.updated_at;
                item.resultGroup = get(item, 'count.group', 0);
                item.settingCollapse = get(item, 'search_setting.collapse', null);
                item.jurisdictions = item.authority || '';
                item.showRange = false;
                item.patentType = item.db_type || ['A', 'B', 'U', 'D'];
                item.stemming = get(item, 'search_setting.stem', '');
                item.rangePopperKey = `rangePopper${index}`;
                item.specialId = item.special_id || '';
                item.canSendDocApi = item.source === 'SEMANTIC' || item.source === 'BULK';
                item.export_status = status[item.exportStatus] || '';
            });
        }
    });
    return newdata;
}

// analystic 双层
export function analyticOther(data, keyMap, type) {
    let newdata = dataFilter(data, keyMap, type);
    const status = ['PENDING', 'PENDING', 'SUCCESS', 'FAIL'];
    newdata.history_maps && newdata.history_maps.forEach(items => {
        items.date = formatDateTime(items.date, 'date');
        if (items.data && items.data.length) {
            items.data.forEach(item => {
                item.dayTime = items.date;
                item.q = item.q ? item.q.replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
                if (item.rawType === 'export' || item.rawType === 'export_paper') {
                    item.export_status = status[item.exportStatus] || '';
                    item.exportFormat = item.exportFormat?.toUpperCase();
                }
                if (item.rawType === 'file_wrapper') item.export_status = item.result ? item.result.toUpperCase() : '';
                item.contentKey = `contentKey${item.id}`; // content field列计算高度用
                if (item.rawType === 'analysis') item.label_type = `history.type.${item.type.toLowerCase()}`;
            });
        }
    });
    return newdata;
}

// discover to Search
export function discoverSearch (data, keyMap, type) {
    let newdata = dataFilter(data, keyMap, type);
    newdata && newdata.history_maps && newdata.history_maps.forEach(item => {
        if (item.data) {
            let query_layout = get(item, 'data.query_param.query_layout') || queryItem2queryLayoutItem(get(item, 'data.query_param.query'));
            const dataExplorerQueryType = get(item, 'data.query_param.query.must[0].any[0].query_type');
            item.q = dataExplorerQueryType
                ? dataExplorerItem2Text(get(item, 'data.query_param.query.must[0].any[0]'))
                : queryLayoutItem2Text(query_layout);
            item.createTime = formatDateTime(item.data.time);
            item.updateTime = formatDateTime(item.data.updated_at);
            item.dataType = item.data.data_type;
            item.resultCount = item.dataType === 'ALL' || dataExplorerQueryType ? '-' : formatNumberByKilo(item.data.last_result_count);
            item.id = item.data.id;
            item.label_type = `history.discoveryType.${item.dataType}`;
        }
    });
    /* 过滤脏数据 */
    newdata.history_maps = newdata.history_maps.filter(item => item.q);
    return newdata;
}

// discover to Export
export function discoverExport (data, keyMap, type) {
    let newdata = dataFilter(data, keyMap, type);
    const typeRelation = {
        1: 'PATENT',
        2: 'MA',
        3: 'RESEARCH_FUNDING',
        4: 'VC_INVESTMENT',
        5: 'MARKET_REPORT',
        6: 'NEWS',
        7: 'ORGANIZATION',
        8: 'PAPER',
        9: 'TECH_OFFERING',
        12: 'TECH_BLOG',
        13: 'PERSON',
        14: 'GRANT',
        15: 'EVENT_NEWS',
        16: 'CLINICAL_TRIAL',
        17: 'EXPERTS',
        21: 'KEY_PLAYER',
        22: 'STARTUP',
        23: 'RESEARCH_INSTITUTION',
        24: 'FAST_GROWING',
        25: 'NEW_ENTRANT',
        26: 'INVESTOR',
        27: 'COMPANY_BETA',
    };
    newdata.history_maps = mergeDate(newdata.history_maps);
    newdata.history_maps.forEach(items => {
        if (items.data && items.data.length) {
            items.data.forEach(item => {
                const time = formatDateTime(item.time);
                const HHmm = dayjs(time).format('HH:mm');
                item.time = HHmm;
                item.dataType = item.search_request && item.search_request.repository ? typeRelation[item.search_request.repository] : '';
                item.label_type = item.dataType ? `history.discoveryType.${item.dataType}` : '';
                item.q = item2Text(item);
                item.rawType = 'export';
                item.exportDownloadUrl = item.download_url;
                item.exportStatus = item.export_status === 'SUCCESS' ? 2 : 0;
            });
        }
    });
    return newdata;
}

// chemical 单层
export function chemicalFilter (data, keyMap, type) {
    // 主要是多了一层data 后面都统一成可map的数据在第一层
    let newdata = dataFilter(data, keyMap, type);
    newdata.history_maps.forEach(item => {
        item.id = item.history_id;
        item.createTime = formatDateTime(item.time);
        item.updateTime = formatDateTime(item.update_at);
        item.resultCount = get(item, 'history_params.hits', '-');
    });
    // newdata.history_maps = mergeDate(newdata.history_maps);
    return newdata;
}

// chemical 双层
export function chemicalDbFilter (data, keyMap, type) {
    // 主要是多了一层data 后面都统一成可map的数据在第一层
    let newdata = dataFilter(data, keyMap, type);
    const fileType = {
        xls: 'XLS',
        csv: 'CSV',
        sdf: 'SDF',
    };
    newdata.history_maps = mergeDate(newdata.history_maps);
    newdata.history_maps.forEach(items => {
        if (items.data && items.data.length) {
            items.data.forEach(item => {
                const time = formatDateTime(item.time);
                const HHmm = dayjs(time).format('HH:mm');
                item.time = HHmm;
                item.id = item.history_id;
                item.fileType = fileType[get(item, 'history_params.request.file_type[0]', '')];
                // 先取inchi_keys的长度，没有在利用from、to字段去计算
                item.resultCount = item.history_params.request ? item.history_params.request.inchi_keys ? item.history_params.request.inchi_keys.length : item.history_params.request.to - item.history_params.request.from + 1 : 0;
                item.templateName = item.history_params.request && item.history_params.request.template_name ? `history.templates.${item.history_params.request.template_name}` : '';
                item.export_status = item.status;
                item.fromSource = item.history_params.request && item.history_params.request.source ? item.history_params.request.source : '';
                item.pq = item.history_params.request && item.history_params.request.query ? item.history_params.request.query.pq : '';
                item.chemicalFormulaCount = item.history_params.hits || 0;
                item.contentKey = `contentKey${item.history_id}`; // content field列计算高度用
                item.exportDownloadUrl = item.expired ? '' : item.download_url; // 导出用
                item.rawType = item.history_type.toLowerCase(); // 导出用
                item.exportStatus = item.status === 'SUCCESS' ? 2 : 0; // 导出用
                item.history_type = item.history_type ? `history.filter.${item.history_type}` : '';
                item.historySourceText = item.history_source ? `history.filter.${item.history_source}` : '';
                item.exportFields = [];
                // 因为layout里的key值是动态的
                if (item.history_params.request && item.history_params.request.layout) {
                    Object.keys(item.history_params.request.layout).forEach(key => {
                        item.exportFields = item.exportFields.concat(item.history_params.request.layout[key]);
                    });
                    item.exportFields = Array.from(new Set(item.exportFields)).map(item => {
                        return item.toLowerCase();
                    });
                }
            });
        }
    });
    return newdata;
}

export function discoveryIds(params) {
    let ids = '';
    params.ids.forEach(id => {
        ids += `${id},`;
    });
    return ids.substring(0, ids.lastIndexOf(','));
}
